export const CREATE_TEMPORARY_ITEM = 'CREATE_TEMPORARY_ITEM';

export const createTemporaryItem = ({ settings, id, context }) => ({
  type: CREATE_TEMPORARY_ITEM,
  settings,
  id,
  context,
});
